import {LandingPage} from "./../../models/LandingPage";

let landingPagesApi = {
    async get(token, companyId, filters){
        let response = await window.axios.get('/api/landingPages', {
            params:{
                api_token:token,
                company_id:companyId,
                relationships:[],
                ...filters
            }
        });

        return response.data.map(l=>new LandingPage(l));
    }
}

export default landingPagesApi